module.exports = __webpack_public_path__ + "static/headphones-reviews-slider-section-f05a6c4eb799257f9fc1687a5392081f.png";